module.exports = __webpack_public_path__ + "media/images/recruitment/landing/feature02-f03ab786cc264f3e044765dd90d151a3.svg";